import { FC } from 'react';

export interface Props {
  label: string;
  color?: string;
}

export const Badge: FC<Props> = ({ label, color = 'grey-50' }) => {
  return (
    <div className={`bg-${color} w-fit h-fit rounded-lg px-2 py-1 text-primary font-bold text-xs`}>
      {label}
    </div>
  );
};
